import { LmgService } from "../resource";

const BillingModule = {
  namespaced: true,
  state: {
    datas: [],
    billings: {},
    invoice_billings: [],
    invoice_status: [
        { ID: 0, Name: "All" },
        { ID: 1, Name: "รอชำระเงิน" },
        { ID: 2, Name: "ชำระเงินแล้ว" },
        { ID: 3, Name: "ยกเลิก" }
      ],
    isLoading: false,
    isLoadingBilling: false,
    isLoadingInvoiceBillings: false,
    // Monotonic counters — every list* call bumps its counter; late
    // responses whose seq != the current counter are dropped so stale
    // results can't overwrite fresher ones and the buttons can safely
    // stay click-guarded.
    _listDataSeq: 0,
    _listBillingSeq: 0,
    _invoiceBillingsSeq: 0,
  },
  mutations: {
    SET_DATAS(state, payload) {
      state.datas = payload;
    },
    SET_BILLINGS(state, payload) {
      state.billings = payload;
    },
    SET_INVOICE_BILLINGS(state, payload) {
      state.invoice_billings = payload;
    },
  },
  actions: {
    createData({ commit, state }, payload) {
      return LmgService.InvoiceCreate(payload);
    },
	paidData({ commit, state }, payload) {
			return LmgService.InvoicePaid(payload);
	},	
	reportData({ commit, state }, payload) {
		return LmgService.InvoiceReport(payload);
	},
	// เพิ่มรายการขายเข้าใบวางบิลเดิม — payload { InvoiceID, BillingList:[], Note }.
	// Errors bubble to the caller so the view can show Msg (i18n key) + Cause.
	addBillings({ commit, state }, payload) {
		return LmgService.InvoiceAddBillings(payload);
	},


    async listData({ commit, state },payload) {
      state._listDataSeq += 1;
      const mySeq = state._listDataSeq;
      state.isLoading = true;
      try {
        const data = await LmgService.InvoiceList(payload);
        if (mySeq !== state._listDataSeq) return;
        if (data.data.Data == null) {
          commit("SET_DATAS", []);
        } else {
          commit("SET_DATAS", data.data.Data);
        }
        state.isLoading = false;
      } catch (err) {
        if (mySeq !== state._listDataSeq) return;
        commit("SET_DATAS", []);
        state.isLoading = false;
      }
    },

	async listBilling({ commit, state },payload) {
		state._listBillingSeq += 1;
		const mySeq = state._listBillingSeq;
		state.isLoadingBilling = true;
		try {
		  const data = await LmgService.InvoiceBillingList(payload);
		  if (mySeq !== state._listBillingSeq) {
			// A newer listBilling call was issued while this one was in flight.
			// Drop this response so fresher results aren't overwritten.
			return;
		  }
		  if (data.data.Data == null) {
			commit("SET_BILLINGS", []);
		  } else {
			commit("SET_BILLINGS", data.data.Data);
		  }
		  state.isLoadingBilling = false;
		} catch (err) {
		  if (mySeq !== state._listBillingSeq) return;
		  commit("SET_BILLINGS", []);
		  state.isLoadingBilling = false;
		}
	  },
	clearBilling({ commit, state },payload) {
		  commit("SET_BILLINGS", []);
	},

	async listInvoiceBillings({ commit, state }, invoiceID) {
		state._invoiceBillingsSeq += 1;
		const mySeq = state._invoiceBillingsSeq;
		state.isLoadingInvoiceBillings = true;
		try {
			const data = await LmgService.InvoiceBillings(invoiceID);
			if (mySeq !== state._invoiceBillingsSeq) return;
			commit("SET_INVOICE_BILLINGS", data.data.Data == null ? [] : data.data.Data);
			state.isLoadingInvoiceBillings = false;
		} catch (err) {
			if (mySeq !== state._invoiceBillingsSeq) return;
			commit("SET_INVOICE_BILLINGS", []);
			state.isLoadingInvoiceBillings = false;
		}
	},

	clearInvoiceBillings({ commit }) {
		commit("SET_INVOICE_BILLINGS", []);
	}


  },
  getters: {
    getData(state) {
      return state.datas;
    },
	getBilling(state) {
		return state.billings;
	  },
	isLoading(state) {
		return state.isLoading;
	},
	isLoadingBilling(state) {
		return state.isLoadingBilling;
	},
	getInvoiceStatus(state) {
		return state.invoice_status;
	},
	getInvoiceBillings(state) {
		return state.invoice_billings;
	},
	isLoadingInvoiceBillings(state) {
		return state.isLoadingInvoiceBillings;
	}
  }
};

export default BillingModule;
